import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SelectionProvider } from './contexts/SelectionContext';
import { Toaster } from 'sonner';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { SelectionBar } from './components/SelectionBar';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { DiamondCatalog } from './pages/DiamondCatalog';
import { DiamondDetail } from './pages/DiamondDetail';
import { UserDashboard } from './pages/UserDashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import '@/App.css';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <AuthProvider>
      <SelectionProvider>
        <BrowserRouter>
         <ScrollToTop />
          <div className="App">
            <Navigation />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/catalog" element={<DiamondCatalog />} />
              <Route path="/diamonds/:id" element={<DiamondDetail />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <UserDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute adminOnly>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            <SelectionBar />
            <Footer />
            <Toaster position="top-right" richColors />
          </div>
        </BrowserRouter>
      </SelectionProvider>
    </AuthProvider>
  );
}

export default App;